
































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseFormulirCard from "@/BaseFormulirCard.vue";
import CommonFormulir, { EnFormulirCategory } from "@/services/CommonFormulir";
import BaseFormulir from "@/BaseFormulir";
import YaTidak from "@/components/pemeriksaan/tabs/rekam-medis/okupasi-terapi/YaTidak.vue";

import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";

import pdf from "vue-pdf";
import moment from "moment";
import FormulirAsesmenOkupasiTerapi from "@/store/modules/FormulirAsesmenOkupasiTerapi";

const KOMPONEN_ITEMS = [
  { key: "motorik", label: "A. Motorik" },
  { key: "sensorik", label: "B. Sensorik" },
  { key: "cognitive", label: "C. Cognitive" },
  { key: "perilaku", label: "D. Perilaku" },
  { key: "social_skill", label: "E. Social Skill" }
];

@Component({
  components: {
    CardModalTtd,
    BaseFormulirCard,
    YaTidak,
    pdf
  }
})
export default class FormulirAsesmenOkupasiTerapiTabPage extends BaseFormulir {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["11"];
  formSvc = new CommonFormulir(EnFormulirCategory.AsesmenOkupasiTerapi);
  formStore = FormulirAsesmenOkupasiTerapi;

  komponenItems = KOMPONEN_ITEMS;

  saving = false;
  loadedRatio = 0;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  tglPemeriksaanShow = false;
  tglPemeriksaan = moment().format("YYYY-MM-DD");
  keluhan = null;
  adl = null;
  produktivitas = null;
  leisure = null;
  komponen: Record<string, string | null> = {
    motorik: null,
    sensorik: null,
    cognitive: null,
    perilaku: null,
    social_skill: null
  };
  diagnosisOt = null;
  rencanaTindakan = null;

  mounted() {
    this.changedataForm(this.dataForm);
  }

  get pdfUrl() {
    return this.dataForm
      ? this.getPdfUrl(
          EnFormulirCategory.AsesmenOkupasiTerapi,
          this.dataForm.id
        )
      : null;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register,
      pasien_rm: this.pasien.rm,
      unit_id: this.user.unit_id,
      surat_date: moment().format("YYYY-MM-DD"),
      signee_user_id: this.user.id,
      creator_user_id: this.user.id,
      content: Object.assign(
        {
          tgl_pemeriksaan: this.tglPemeriksaan,
          keluhan: this.keluhan,
          adl: this.adl,
          produktivitas: this.produktivitas,
          leisure: this.leisure,
          diagnosis_ot: this.diagnosisOt,
          rencana_tindakan: this.rencanaTindakan
        },
        this.komponen
      )
    };
  }

  setKomponen(key: string, val: string) {
    this.komponen = Object.assign({}, this.komponen, { [key]: val });
  }

  save() {
    if (this.saving) return;
    this.saving = true;

    const action = this.dataForm
      ? this.formSvc.update(this.dataForm.id, this.input)
      : this.formSvc.create(this.input);

    action
      .then(() => {
        appModule.NoticeDelay("Berhasil Simpan");
        this.close();
        this.formStore.getByRegister(this.register);
      })
      .finally(() => {
        this.saving = false;
      });
  }

  close() {
    this.expandInput = false;
  }

  tglPemeriksaanFormat() {
    return this.tglPemeriksaan
      ? moment(this.tglPemeriksaan, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  @Watch("dataForm")
  changedataForm(val) {
    const c = val ? val.content || {} : {};

    this.tglPemeriksaan = c.tgl_pemeriksaan || moment().format("YYYY-MM-DD");
    this.keluhan = c.keluhan || null;
    this.adl = c.adl || null;
    this.produktivitas = c.produktivitas || null;
    this.leisure = c.leisure || null;
    this.diagnosisOt = c.diagnosis_ot || null;
    this.rencanaTindakan = c.rencana_tindakan || null;
    this.komponen = KOMPONEN_ITEMS.reduce((acc, item) => {
      acc[item.key] = c[item.key] || null;
      return acc;
    }, {} as Record<string, string | null>);
  }
}
